var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.paymentsToDisplay.length > 0
        ? _c("h3", [_vm._v(_vm._s(_vm.$l10n.__("Liste des paiements")))])
        : _c("h3", [
            _vm._v(_vm._s(_vm.$l10n.__("Ajouter un nouveau règlement")))
          ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "aright" },
        [
          _vm.hasReconciledPayment
            ? _c("CompassButton", {
                attrs: { label: _vm.wordingBtnCollapse, type: "tertiary" },
                on: { click: _vm.togglePaymentsDisplay }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.paymentsToDisplay.length > 0,
              expression: "paymentsToDisplay.length > 0"
            }
          ],
          class: {
            "b-1 br": true,
            "br-bottom-0": _vm.paymentsToAdd.length > 0
          },
          staticStyle: { width: "100%" },
          attrs: { data: _vm.paymentsToDisplay, rowKey: _vm.rowKey }
        },
        [
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.date"), width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$filters.saasDateFormatted(scope.row.date)) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "ref", label: _vm.$t.__("common.labels.reference") }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__("common.labels.payment_amount"),
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$filters.numberFormatCurrency(scope.row.amount)
                        ) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__("common.labels.payment_status"),
              width: "150"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.payStepLabel !== undefined
                      ? _c("div", [
                          _c("div", {
                            class: "chip chip-" + scope.row.payStepChip
                          }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(scope.row.payStepLabel) +
                              "\n                "
                          )
                        ])
                      : _c("div", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$l10n.__("Nouveau paiement")) +
                              "\n                "
                          )
                        ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__("common.actions.reconcile"),
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { disabled: scope.row.isReconciled },
                        on: {
                          change: function($event) {
                            return _vm.updateStore(
                              scope.row.storeId,
                              scope.row.payid,
                              $event
                            )
                          }
                        },
                        model: {
                          value: scope.row.isChecked,
                          callback: function($$v) {
                            _vm.$set(scope.row, "isChecked", $$v)
                          },
                          expression: "scope.row.isChecked"
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$l10n.__("Rapproché")) +
                            "\n                "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.paymentsToAdd.length > 0,
              expression: "paymentsToAdd.length > 0"
            }
          ],
          class: {
            "el-table--disable-row-hover br": true,
            "b-1": !_vm.paymentsToDisplay.length,
            "bl-1 br-1 bb-1 br-top-0": _vm.paymentsToDisplay.length > 0
          },
          staticStyle: { width: "100%" },
          attrs: { data: _vm.paymentsToAdd, rowKey: _vm.rowKeyNewPayment }
        },
        [
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.date"), width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$filters.saasDateFormatted(scope.row.date)) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.reference") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-input", {
                      attrs: {
                        placeholder: _vm.$t.__("common.labels.a_reference"),
                        disabled: scope.row.isLocked
                      },
                      model: {
                        value: scope.row.ref,
                        callback: function($$v) {
                          _vm.$set(scope.row, "ref", $$v)
                        },
                        expression: "scope.row.ref"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__("common.labels.payment_amount"),
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.isSaleDoc
                      ? _c("input-number", {
                          attrs: {
                            precision: _vm.numberFormat.precision,
                            separatorDecimal: _vm.numberFormat.decimal,
                            separatorThousand: _vm.numberFormat.thousand,
                            disabled: scope.row.isLocked,
                            controls: false,
                            placeholder: _vm.$t.__("common.labels.amount"),
                            size: "small",
                            min: 0.01
                          },
                          model: {
                            value: scope.row.amount,
                            callback: function($$v) {
                              _vm.$set(scope.row, "amount", $$v)
                            },
                            expression: "scope.row.amount"
                          }
                        })
                      : _c("input-number", {
                          attrs: {
                            precision: _vm.numberFormat.precision,
                            separatorDecimal: _vm.numberFormat.decimal,
                            separatorThousand: _vm.numberFormat.thousand,
                            disabled: scope.row.isLocked,
                            controls: false,
                            placeholder: _vm.$t.__("common.labels.amount"),
                            size: "small",
                            min: 0.01
                          },
                          model: {
                            value: scope.row.amount,
                            callback: function($$v) {
                              _vm.$set(scope.row, "amount", $$v)
                            },
                            expression: "scope.row.amount"
                          }
                        })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.type"), width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        model: {
                          value: scope.row.pay_type,
                          callback: function($$v) {
                            _vm.$set(scope.row, "pay_type", $$v)
                          },
                          expression: "scope.row.pay_type"
                        }
                      },
                      _vm._l(_vm.payTypes, function(type) {
                        return _c("el-option", {
                          key: type.id,
                          attrs: { label: type.value, value: type.id }
                        })
                      }),
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__("common.actions.reconcile"),
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("i", {
                      staticClass: "icon-trash link",
                      staticStyle: { float: "right" },
                      on: {
                        click: function($event) {
                          return _vm.removeSelectedLine(scope.row.id)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("rb-new-payment-checkbox", {
                      attrs: {
                        default: false,
                        document: _vm.document,
                        reference: scope.row.ref,
                        pay_type: scope.row.pay_type,
                        amount: scope.row.amount
                      },
                      on: {
                        "new-payment-confirmed": function($event) {
                          return _vm.removeSelectedLine(scope.row.id)
                        }
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "aright" },
        [
          _vm.canAddPayment
            ? _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__(
                    "common.actions.add_and_reconcile__new_payment"
                  ),
                  type: "tertiary"
                },
                on: { click: _vm.addNewPayment }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }